export class PostRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid post request: ${detail}`);
    this.name = 'PostRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const isId = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
const isVideo = value => /\.(mp4|webm|mov|m4v)(?:[?#]|$)/i.test(value);
const isMediaUrl = value => {
  if (typeof value !== 'string' || value.length > 2048) return false;
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password;
  } catch { return false; }
};

export function readPostId(id) {
  if (!isId(id)) throw new PostRequestContractError('expected an ObjectId.');
  return id;
}
export function readPostWriteRequest(body, update = false) {
  if (!isRecord(body) || typeof body.content !== 'string' || !body.content.trim() || body.content.trim().length > 1000) {
    throw new PostRequestContractError('write between 1 and 1000 characters.');
  }
  if (!update) {
    const media = body.media === undefined ? [] : body.media;
    const thumbnails = body.mediaThumbnails === undefined ? [] : body.mediaThumbnails;
    if (body.community != null && !isId(body.community)
      || body.tags !== undefined && (!Array.isArray(body.tags) || !body.tags.every(tag => typeof tag === 'string'))
      || !Array.isArray(media) || media.length > 10 || !media.every(isMediaUrl) || new Set(media).size !== media.length
      || media.length > 1 && media.some(isVideo)
      || !Array.isArray(thumbnails) || thumbnails.length > 0 && thumbnails.length !== media.length
      || !thumbnails.every(isMediaUrl) || thumbnails.some(isVideo)) {
      throw new PostRequestContractError('invalid community, tags, media or thumbnail order/count.');
    }
  }
  return body;
}
export function readPostCommentRequest(body) {
  if (!isRecord(body) || typeof body.comment !== 'string' || !body.comment.trim() || body.comment.trim().length > 500
    || body.parentCommentId != null && !isId(body.parentCommentId)) {
    throw new PostRequestContractError('write between 1 and 500 characters and use a valid optional reply parent.');
  }
  return body;
}
export function readPostFeedRequest(query) {
  if (!isRecord(query)
    || ['limit', 'page'].some(key => query[key] !== undefined && !((typeof query[key] === 'number'
      || typeof query[key] === 'string' && /^\d+$/.test(query[key])) && Number.isSafeInteger(Number(query[key])) && Number(query[key]) > 0))
    || query.pagination !== undefined && query.pagination !== '' && query.pagination !== 'cursor'
    || query.before !== undefined && (typeof query.before !== 'string' || !Number.isFinite(Date.parse(query.before)))
    || query.beforeId !== undefined && !isId(query.beforeId)
    || query.authorId !== undefined && !isId(query.authorId)
    || (query.before !== undefined) !== (query.beforeId !== undefined)
    || query.cursor !== undefined && (typeof query.cursor !== 'string' || query.cursor.length > 512)) {
    throw new PostRequestContractError('invalid feed pagination.');
  }
  return query;
}

export function readPostReactionRequest(postId, emoji, commentId) {
  readPostId(postId);
  if (commentId !== undefined) readPostId(commentId);
  if (emoji !== null && !['👍', '❤️', '😂', '😮', '😢', '🙏'].includes(emoji)) throw new PostRequestContractError('choose a supported reaction.');
  return {emoji};
}
